// @unocss-include
import { jsx as _jsx } from "react/jsx-runtime";
export const withProps = (Component, extras) => {
    return (props) => {
        return _jsx(Component, Object.assign({}, props, extras));
    };
};
export const withoutProps = (Component, remove) => {
    return (props) => {
        return _jsx(Component, Object.assign({}, props));
    };
};
//# sourceMappingURL=withProps.js.map